// userService.js
import { get, post, put, Delete } from './common';


export const createTemplate = (data) => {
    return post('template', data, { "content-type": "multipart/form-data"});
}

export const updateTemplate = (templateId, data) => {
  return put('template/'+templateId, data, { "content-type": "multipart/form-data"});
}

export const getTemplateById = (templateId) => {
  return get('template/'+templateId);
}

export const deleteTemplateById = (templateId) => {
  return Delete('template/'+templateId);
}

export const getTemplates = (filterData ) => {
  return get('template', filterData);
};

export const uploadTemplateImage = (templateId, data) => {
  return post('template/'+templateId+'/upload-image', data, { "content-type": "multipart/form-data"});
}
